import { render, staticRenderFns } from "./ListReportEdc.vue?vue&type=template&id=7fa620cd"
import script from "./ListReportEdc.vue?vue&type=script&lang=js"
export * from "./ListReportEdc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports